













import {
  Component,
  Vue,
  Prop, Watch,
} from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class InputField extends Vue {
  @Prop({default: ''}) private value!: string;
  @Prop({default: ''}) private label!: string;
  @Prop({default: ''}) private hint!: string;
  @Prop({default: false}) private hideDetails!: boolean;
  @Prop({default: false}) private showHint!: boolean;
  @Prop({default: false}) private isDisabled!: boolean;
  @Prop() private rules!: any;
  private model: string = '';

  @Watch('model')
  private onModelChange(value: string) {
    this.$emit('value', value);
  }

  @Watch('value', {immediate: true})
  private onExternalValueChange(value: string) {
    Vue.set(this, 'model', this.value);
  }
}
